import React from 'react';
import PropTypes from 'prop-types';
import { isNonEmptyString, createCustomPropType } from '../../../../js/app/react/validators';
import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { BACKEND_KEY } from '../PersonalInfoWorkflowConstants';
import AdvForm from '../../../CommonComponents/AdvForm';
import { inputTextChanged } from '../../../Profile/Accounts_react/AccountsUtils';
import { validateAge } from '../PersonalInfoWorkflowValidator';
import ageShouldSkip from './AgeShouldSkip';
import InputAge from '../../InputAge/InputAgeView';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';

const getTitle = hasPartner => {
  if (hasPartner) {
    return 'What are your current ages?';
  }
  return 'What is your current age?';
};

const AgeView = ({
  branch,
  clientId,
  hasPartner,
  partner,
  principal,
  store,
  workflowId,
  isGoingForward,
}) => (
  <AdvWorkflowStep
    branch={branch}
    workflowId={workflowId}
    canSkip={ageShouldSkip(isGoingForward, hasPartner, principal.Age, partner.Age)}
    id="Age"
  >
    <h2>{getTitle(hasPartner)}</h2>
    <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.Age`} />
    <AdvForm>
      <ul className="horizontal">
        <li>
          <InputAge
            maxLength={3}
            isUnder
            placeholder={principal.FirstName}
            className="xsm text-center"
            value={principal.Age}
            id={`adv-${principal.FirstName}-age`}
            onChange={inputTextChanged(clientId, store(workflowId), `${BACKEND_KEY}.Principal.Age`)}
          />
        </li>
        {hasPartner && (
          <li>
            <InputAge
              maxLength={3}
              isUnder
              placeholder={partner.FirstName}
              className="xsm text-center"
              value={partner.Age}
              id={`adv-${partner.FirstName}-age`}
              onChange={inputTextChanged(clientId, store(workflowId), `${BACKEND_KEY}.Partner.Age`)}
            />
          </li>
        )}
      </ul>
    </AdvForm>

    <Navigation
      nextIterators={[]}
      dirtyGraphNodes={[]}
      validator={validateAge(hasPartner, principal.Age, partner.Age)}
      validationId={`${BACKEND_KEY}.Age`}
      workflowId={workflowId}
      backendKey={BACKEND_KEY}
      validatedOnClick={() => {
        const event = hasPartner ? 'partner_age_info_completed' : 'age_info_complete';
        workflowAnalyticsEvents(workflowId, event);
      }}
      onPostProcess={data => {
        if (data[BACKEND_KEY].Principal && data[BACKEND_KEY].Principal.Dob) {
          delete data[BACKEND_KEY].Principal.Dob;
        }

        if (data[BACKEND_KEY].Partner && data[BACKEND_KEY].Partner.Dob) {
          delete data[BACKEND_KEY].Partner.Dob;
        }

        return data;
      }}
    />
  </AdvWorkflowStep>
);

AgeView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: PropTypes.string.isRequired,
  store: PropTypes.func.isRequired,
  hasPartner: PropTypes.bool.isRequired,
  partner: PropTypes.shape({}).isRequired,
  principal: PropTypes.shape({}).isRequired,
  isGoingForward: PropTypes.bool.isRequired,
};

export default AgeView;
